/* Helpers for the Spotify artist picker on artist pages (spotifyArtistIds).
 *
 * The page stores plain Spotify ids; the picker shows artists. Kept pure so
 * the parts that decide what gets saved are testable without React. */

// "5.1M", "12K", "830" — enough to tell namesakes apart at a glance.
const formatFollowers = (count) => {
  if (typeof count !== 'number' || Number.isNaN(count)) return null;
  if (count >= 1e6) return `${(count / 1e6).toFixed(count >= 1e7 ? 0 : 1).replace(/\.0$/, '')}M`;
  if (count >= 1e3) return `${Math.round(count / 1e3)}K`;
  return String(count);
};

// One line under the name: followers, popularity, genres.
const describeArtist = (artist) => {
  if (!artist) return '';
  const parts = [];
  const followers = formatFollowers(artist.followers);
  if (followers) parts.push(`${followers} followers`);
  if (typeof artist.popularity === 'number') parts.push(`popularity ${artist.popularity}`);
  if (Array.isArray(artist.genres) && artist.genres.length) parts.push(artist.genres.join(', '));
  return parts.join(' · ');
};

// The ids to save, in the order the editor picked them, without repeats.
const idsFromSelection = (selection) => {
  const seen = new Set();
  return (Array.isArray(selection) ? selection : [])
    .map(artist => (artist && typeof artist.id === 'string' ? artist.id : null))
    .filter(id => id && !seen.has(id) && seen.add(id));
};

// Artists for ids, in id order; an id nothing was found for still shows.
const selectionFromIds = (ids, artists) => {
  const byId = new Map((Array.isArray(artists) ? artists : []).filter(Boolean).map(artist => [artist.id, artist]));
  return (Array.isArray(ids) ? ids : []).map(id => byId.get(id) || { id, name: null });
};

module.exports = {
  formatFollowers, describeArtist, idsFromSelection, selectionFromIds,
};
